<template lang="html">
  <layout>
    <v-container grid-list-xl>
      <v-layout row wrap justify-space-between>
        <v-toolbar flat dense light color="rgba(0,0,0,0)">
          <v-toolbar-title>Remodelers</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
        <v-flex >
          <v-data-table
            :headers="headers"
            :items="remodelers"
            :search="search"
            :pagination.sync="pagination"
            class="elevation-3">
            <template v-slot:items="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.bbb_rating }}</td>
              <td>{{ props.item.years_in_business }}</td>
              <td>{{ props.item.number_of_sales_people }}</td>
              <td>
                <v-chip v-if="props.item.status" :color="getColor(props.item.status)" dark>{{ props.item.status }}</v-chip>
              </td>
              <td>{{ props.item.jobs_count }}</td>
              <td>{{ props.item.manager_email }}</td>
              <td>
                <v-btn flat icon color="primary" :to="{name: 'adminRemodeler', params:{id: props.item.id}}">
                  <v-icon>fas fa-edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import Layout from '@/shared/Layout'

export default {
  data () {
    return {
      search: '',
      remodelers: [],
      pagination: {
        rowsPerPage: 10,
        sortBy: 'status'
      },
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Rating',
          value: 'bbb_rating'
        },
        {
          text: 'Yrs in Business',
          value: 'years_in_business'
        },
        {
          text: '# Sales People',
          value: 'number_of_sales_people'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: '# Jobs',
          value: 'jobs_count'
        },
        {
          text: 'Manager',
          value: 'manager_email'
        },
        {
          text: 'Actions',
          value: 'name'
        }
      ]
    }
  },
  components: {
    Layout
  },
  methods: {
    getColor (status) {
      if (status === 'APPROVED') return 'green'
      else if (status === 'APPROVAL PENDING') return 'orange'
      else return 'red'
    }
  },
  mounted () {
    this.$http({
      method: 'get',
      url: '/admin/remodelers'
    }).then((response) => {
      this.remodelers = response.data
    })
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/Remodelers/index.vue